import React, { useState } from 'react';
import { Modal, Form, Button } from 'antd';
import { ClearOutlined, CloseOutlined } from '@ant-design/icons';
import SpaceTypeFilters from './Filters/SpaceTypeFilters';
import DateFilter from './Filters/DateFilter';
import OrganizationFilter from './Filters/OrganizationFilter';


interface FiltersModalProps {
  visible: boolean;
  onCancel: () => void;
  onApply: (filters: any) => void;
  onClear: () => void;
  initialFilters?: any;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  visible,
  onCancel,
  onApply,
  onClear,
}) => {
  const [form] = Form.useForm();
  const [filters, setFilters] = useState<any>({
    spaceType: [],
    dates: [],
    organizationIds: [],
  });
  const handleApply = () => {
    onApply(filters);
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          Filters
          <CloseOutlined style={{ marginLeft: 'auto', cursor: 'pointer' }} onClick={onCancel} />
        </div>
      }
      visible={visible}
      onCancel={onCancel}
      footer={[

        <Button key="apply" className="aply-btn" onClick={handleApply}>
          Apply Filters
        </Button>
      ]}
      width={600}
      className="filters-modal"
      closeIcon={< ClearOutlined />}
    >
      <div style={{ display: 'flex', gap: '5px' }}>
        <SpaceTypeFilters filters={filters} setFilters={setFilters} />
        <DateFilter filters={filters} setFilters={setFilters} />
        <OrganizationFilter filters={filters} setFilters={setFilters} />
      </div>
    </Modal >
  );
};

export default FiltersModal;